
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import {ActionDefinition, Duty, SurveyJsUiClient, SurveyView} from '../../backend/backendapi';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import DutyStore from '../../../stores/DutyStore';
import {initClient} from "../../../api";

@Component({
  components: {
    vSelect,
  },
})
export default class DefinitionEditorSurveyResultMqttSpecific extends Vue {
  @Prop({ required: true })
  definition!: ActionDefinition;
  @Prop({ required: true })
  parsedJsonParameters!: any;

  readonly dutyStore = new DutyStore();
  readonly surveyApi = initClient(SurveyJsUiClient);

  readonly surveys: SurveyView[] = []

  public canSaveChanged() {
    this.$nextTick(() => {
      let res = (this.dutyId !== null) && (this.surveyId !== null);
      this.$emit("canSaveChanged", res);
    });
  }

  get duties(): Duty[] {
    const ret = [...this.dutyStore.duties];
    ret.sort((l, r) => l.title.localeCompare(r.title));
    return ret;
  }

  get dutyId(): number | null {
    return this.parsedJsonParameters.dutyId ?? null;
  }

  set dutyId(value: number | null) {
    this.parsedJsonParameters.dutyId = value;
    this.onParsedJsonChanged();
    this.canSaveChanged();
  }

  get surveyId(): string | null {
    return this.parsedJsonParameters.surveyId ?? null;
  }

  set surveyId(value: string | null) {
    this.parsedJsonParameters.surveyId = value;
    this.onParsedJsonChanged();
  }

  async mounted(): Promise<void> {
    await this.dutyStore.loadIfAbsent();
    await this.reloadSurveyData();
  }

  onParsedJsonChanged() {
    this.$emit('changed', this.parsedJsonParameters);
    this.canSaveChanged();
  }

  async reloadSurveyData(): Promise<void> {
    const surveys = await this.surveyApi.list();
    this.surveys.splice(0);
    this.surveys.push(...surveys);
  }
}
